import { useEffect, useState } from 'react';
import { useQueryClient, CancelledError } from '@tanstack/react-query';
import { useAuthStateStore, useUserUUID } from '@annunciate/core';
import { syncProgress } from '@annunciate/query';
import { useAppTransitionState } from '../utils';
export const useProgressSynchronizer = () => {
    const [retry, setRetry] = useState(0);
    const state = useAppTransitionState();
    const client = useQueryClient();
    const uuid = useUserUUID();
    const hasAuthInitialized = useAuthStateStore((state) => state.hasAuthInitialized);
    useEffect(() => {
        if (client && hasAuthInitialized && retry < 3) {
            syncProgress(client).catch((err) => {
                if (err instanceof CancelledError) {
                    setRetry((r) => r + 1);
                }
            });
        }
    }, [
        retry,
        hasAuthInitialized,
        !!client,
        state,
        uuid,
    ]);
};
//# sourceMappingURL=useProgressSynchronizer.js.map